<button type="button"
    [attr.type]="type"
    [ngClass]="[buttonSize, buttonType]"
    [ngStyle]="styles"
    [disabled]="disabled"
    (click)="onClick()"
    [style]="style"
    [style]="isIcon && isMobile && onlyIcon? 'padding: 6px 12px !important; border-radius: 50% !important':''">
    <mat-icon *ngIf="isIcon && left && iconType == 'mat-input'" class="mat-icon-tgglbtn" svgIcon="{{iconName}}"></mat-icon>
    <i *ngIf="isIcon && left" [attr.class]="iconName"></i>
    {{ (isIcon && isMobile && onlyIcon ? '':  buttonText) | replaceText }}
    <i *ngIf="isIcon && right" [attr.class]="iconName"></i>
</button>
